import React from 'react';
import ProductPage from '../components/product/ProductPage';
import { personalContactConfig } from '../config/products';

const PersonalContactPage: React.FC = () => {
  return <ProductPage config={personalContactConfig} />;
};

export default PersonalContactPage;
